import _default from './Responsive';
export { _default as default };